import { DOG_CARD_GRID_COLS_CLASS } from "@/components/shared/dogCardGrid";
/* oxlint-disable shadcn/no-arbitrary-values -- content rail custom property is shared by bleed calculations */
export const SECTION_CONTENT_CLASS =
    "page-container [--content-px:var(--spacing-grid-margin)]";
/* oxlint-enable shadcn/no-arbitrary-values */

export const ROW_CLASS = "flex w-full flex-col gap-4";

export const ROW_TITLE_TEXT_CLASS = "text-section-title";

const PHONE_SCROLLER_CLASS =
    "max-md:full-bleed-scroll flex gap-grid-gap pb-2 snap-x snap-mandatory overflow-x-auto overscroll-x-contain scrollbar-none";

const GRID_FROM_MD_CLASS = `md:grid ${DOG_CARD_GRID_COLS_CLASS} md:pb-0 md:snap-none md:overflow-visible`;

export const ROW_LIST_CLASS = `${PHONE_SCROLLER_CLASS} ${GRID_FROM_MD_CLASS}`;

const ROW_LIST_ITEM_CLASS = "w-55 shrink-0 snap-start md:w-auto";

const GRID_CELL_VISIBILITY = [
    "",
    "",
    "",
    "md:hidden lg:block",
    "md:hidden xl:block",
];

export function rowListItemClass(index: number) {
    return `${ROW_LIST_ITEM_CLASS} ${GRID_CELL_VISIBILITY[index] ?? "md:hidden"}`.trimEnd();
}
